import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_EXERCISE_KEY } from '_api/queries/exercise/useGetAllExercise';
import { GET_MY_LIBRARY_EXERCISES_KEY } from '_api/queries/exercise/useGetMyLibraryExercises';

const DELETE_EXERCISE_BY_ID_KEY = 'delete-exercise-by-id';

export const useDeleteExerciseById = () => {
  const queryClient = useQueryClient();

  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/exercise/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_EXERCISE_BY_ID_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_EXERCISE_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_MY_LIBRARY_EXERCISES_KEY] });
      },
    },
  );
};
